import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useGetPurchasedPackageQuery } from 'root-api'
import { purchasedPackageUuidSelector } from 'selectors/scheduling'

// This hook fetches purchased package data in the background when a redeem parameter is present
// It calculates session count information for the given event type
export const usePurchasedPackageData = (eventTypeUuid) => {
  const purchasedPackageUuid = useSelector(purchasedPackageUuidSelector)

  const { data, isLoading: loading, error, refetch } = useGetPurchasedPackageQuery(
    { uuid: purchasedPackageUuid },
    { skip: !purchasedPackageUuid }
  )

  const purchasedPackage = data?.resource

  // Calculate session count from package data
  const { currentSession, numSessions, remainingSessions } = useMemo(() => {
    if (!purchasedPackage || !eventTypeUuid) {
      return { currentSession: null, numSessions: null, remainingSessions: null }
    }

    // Find the item matching the current event type
    const matchingItem = purchasedPackage.purchased_package_items?.find(
      (item) => item.item_uuid === eventTypeUuid && item.item_type === 'event_types'
    )

    if (!matchingItem) {
      return { currentSession: null, numSessions: null, remainingSessions: null }
    }

    const { num_units: numUnits, remaining_units: remainingUnits } = matchingItem
    const current = numUnits - remainingUnits + 1

    return {
      currentSession: current > numUnits ? null : current,
      numSessions: numUnits,
      remainingSessions: remainingUnits
    }
  }, [purchasedPackage, eventTypeUuid])

  return { purchasedPackage, currentSession, numSessions, remainingSessions, loading, error, refetch }
}
